(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["brand-logo"] && !window.DesignMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const logoSwiper = new Swiper('.swiper-logo', {
      loop:true,
      direction: 'horizontal',
      speed: 2000,
      spaceBetween: 30,
      slidesPerView: 'auto',
      freeMode: true,
      // breakpoints: {
      //   320: {
      //     slidesPerView: 4,
      //     spaceBetween: 10
      //   },
      //   768: {
      //     slidesPerView: 5,
      //     spaceBetween: 20
      //   },
      //   1242: {
      //     slidesPerView: 6,
      //     spaceBetween: 40
      //   },
      //   1580: {
      //     slidesPerView: 8,
      //     spaceBetween: 40
      //   }
      // }
    })
    function setSlideWidths() {
        const slides = document.querySelectorAll('.logo-wall-container .swiper-slide');
        slides.forEach(slide => {
            const img = slide.querySelector('img');
            if (img) {
                if (img.complete) {
                    slide.style.width = `${img.offsetWidth + 20}px`;
                } else {
                    img.addEventListener('load', () => {
                        slide.style.width = `${img.offsetWidth + 20}px`;
                    });
                }
            }
        });
    }
    setSlideWidths();
    let lastScrollTop = 0;
    function handleScroll(event) {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (scrollTop > lastScrollTop) {
        logoSwiper.slideNext(400)
      } else {
        logoSwiper.slidePrev(400)
      }
      lastScrollTop = scrollTop;
    }
    window.addEventListener('scroll', handleScroll)
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collections-list-home"] && !window.DesignMode) return;
  try {
    
  $(document).ready(function() {
    let swiperInstance = null;
    const breakpoint = 769;
    function initSwiper() {
      swiperInstance = new Swiper('.swiper-collections',{
        spaceBetween: 35,
        slidesPerView: 6.3
      })
    }
    function checkScreenSize() {
        const windowWidth = $(window).width();
        
        if (windowWidth >= breakpoint) {
            // 屏幕宽度 >= 769px，启用swiper
            if (!swiperInstance) {
                initSwiper();
            }
        } else {
            // 屏幕宽度 < 769px，停用swiper
            if (swiperInstance) {
                swiperInstance.destroy(true, true);
                swiperInstance = null;
            }
        }
    }
    checkScreenSize();
    $(window).on('resize', function() {
        checkScreenSize();
    });
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["our-charity"] && !window.DesignMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
  // const modal = document.getElementById('modal-certificate');
  const certificateImage = document.getElementById('certificate-image');
  
  // 或者使用事件委托监听按钮点击
  document.addEventListener('click', function(event) {
    if (event.target.matches('.view-btn')) {
      const imageUrl = event.target.dataset.imageUrl;
      if (imageUrl) {
        certificateImage.src = imageUrl;
      }
    }
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'related-products'
  var productRecommendationsSection = document.querySelector(".related-products");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".related-products").innerHTML;
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].related-products')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["styles-link"] && !window.DesignMode) return;
  try {
    
  $(document).ready(function() {
    $('.style-item').hover(
      function() {
        const $this = $(this);
        const $siblings = $this.siblings('.style-item');
  
        // --- 1. 处理 active class 的切换 ---
        $this.addClass('active');
        $siblings.removeClass('active');
  
        // --- 2. 处理当前点击元素的图标显隐 ---
        // 找到子元素 .style-icon 并添加 hidden 类
        $this.find('.style-icon').addClass('hidden');
        // 找到子元素 .style-icon-active 并移除 hidden 类
        $this.find('.style-icon-active').removeClass('hidden');
  
        // --- 3. 重置所有兄弟元素的图标状态 ---
        // 显示兄弟元素的 .style-icon
        $siblings.find('.style-icon').removeClass('hidden');
        // 隐藏兄弟元素的 .style-icon-active
        $siblings.find('.style-icon-active').addClass('hidden');
      },
      function() {
        // 鼠标离开时的处理
        const $this = $(this);
        const $siblings = $this.siblings('.style-item');
    
        // --- 1. 移除 active class ---
        $this.removeClass('active');
    
        // --- 2. 恢复当前元素的图标状态 ---
        // 显示 .style-icon
        $this.find('.style-icon').removeClass('hidden');
        // 隐藏 .style-icon-active
        $this.find('.style-icon-active').addClass('hidden');
    
        // --- 3. 恢复所有兄弟元素的图标状态 ---
        // 显示兄弟元素的 .style-icon
        $siblings.find('.style-icon').removeClass('hidden');
        // 隐藏兄弟元素的 .style-icon-active
        $siblings.find('.style-icon-active').addClass('hidden');
    }
    )
  })

  } catch(e) { console.error(e); }
})();
})();
